export const environment = {
  production: false,
  dev: true,
  apiURL: 'https://mobilej21.creatics.org/',
  eventImageBaseURL: 'https://training12.agiletix.com/images/user/cineq_2198',
  passportAssetsBaseURL: 'https://d2ommjggsztk81.cloudfront.net',
  URL: 'https://mobilej21.creatics.org/',
  recaptcha: {
    siteKey: '6LfdzjclAAAAAN17ApukiUMVyTK24OPNaqfzbWaX'
  },
  firebaseLoginMethods: {
    google: true,
    facebook: true,
    apple: true
  },
  firebaseConfig: {
    apiKey: "AIzaSyBU9duw3MsGzABT5wiLcyjVxGC9nsEADhM",
    authDomain: "creatics-live-f0205.firebaseapp.com",
    projectId: "creatics-live-f0205",
    storageBucket: "creatics-live-f0205.appspot.com",
    messagingSenderId: "334225550856",
    appId: "1:334225550856:web:f20f0a742ba2eed5366bbd",
    measurementId: "G-MNLLJMMGCC"
  },
  TALKS_APP_ID: "ty89kyG6",
  TALKJS_SECRET_KEY: "sk_liveB3zL0Keoa6go1Rf3azNce4C9GE1JdC0A",
  STRIPE_PUBLIC_KEY: "pk_test_51Am650ErGLkCJE68PJRsyFE5PLc46imETlFzOBiL6tbxc7bzcTxHDS1bmpYSfKkUkx9LQa61oayZUhAAZfinrGd600VxNPm5Zj"
};
